import React from "react";
import { useTranslation } from "next-i18next";
import dayjs from "dayjs";
import Link from "next/link";

export default function SelectionBlogPosts({
    posts
}) {
    const lastPosts = posts.data.slice(-3)
    const { t } = useTranslation();
    return (
        <div className="selection_blog_posts_container">
            <div className="selection_blog_posts_header">
                <p>{t("selection.blog.desktop")}</p>
            </div>
            <div className="selection_blog_posts_articles">
                {lastPosts.map((post, i) => {
                    const tag = post.attributes.tags.data.map((t) => t.attributes.name);
                    return (
                        <Link href={`/blog/${post.attributes.slug}`} key={i} className="selection_blog_posts_article_card_container">
                            <div className="selection_blog_posts_articles_image_container">
                                <img src={post.attributes.preview_image.data[0].attributes.url} />
                            </div>
                            <div className="selection_blog_posts_article_card_details">
                                <p className="selection_blog_posts_title">{post.attributes.title}</p>
                                <div className="articles_tags_container_selection_blog_posts">
                                    <div className="articles_tags_selection_blog_posts">
                                        <p>{tag}</p>
                                    </div>
                                </div>
                                <div className="selection_blog_posts_author_and_date_container">
                                    <p className="selection_blog_posts_author">écrit par <b>{post.attributes.author}</b></p>
                                    <p className="selection_blog_posts_date">{dayjs(post.attributes.publishedAt).format("DD MMMM YYYY")}</p>
                                </div>
                            </div>
                        </Link>
                    )
                })}
            </div>
        </div>
    );
}
